const subscriptionSettingsKeys = {
  "subscription.settings.manage.payment-required":
    "Update your payment information in the Payment details section below before managing your subscription.",
  "subscription.settings.cancel.scheduled": "Your subscription is already scheduled to end. It will not renew.",
  "subscription.settings.address.label": "Billing address",
  "subscription.settings.address.description": "Update the name and address used for billing.",
  "subscription.settings.address.unavailable": "A billing account is required to update your billing address.",
  "subscription.settings.address.load-error": "We could not load your billing address. Please try again.",
  "subscription.settings.address.save-error": "We could not save your billing address. Please check your address and try again.",
  "subscription.settings.address.retry": "Try again",
  // Section Headers
  "subscription.settings.billing": "Billing",

  // Manage Subscription
  "subscription.settings.manage.label": "Manage subscription",
  "subscription.settings.manage.description": "Add or remove users from your subscription.",

  // Cancel Subscription
  "subscription.settings.cancel.label": "Cancel subscription",
  "subscription.settings.cancel.description": "Cancel your subscription.",

  // Payment Details
  "subscription.settings.payment.label": "Payment details",
  "subscription.settings.payment.description": "Update your payment method.",
  "subscription.settings.payment.no-subscription": "You need an active subscription to update your payment method.",
};

export const subscriptionSettings = {
  ...subscriptionSettingsKeys,
};
